import React from 'react';

import { useNewAccountState, useNewAccountActions } from './NewAccountContext';
import { openNewAccount } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import FormRow from '../../Shared/UI/FormRow/components/FormRow';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const NewAccountForm = () => {
  const state = useNewAccountState();
  const { onResponse, onError, updateFirstName, updateLastName, updatePrimaryEmail, updatePassword, updatePasswordConfirmation, updateInviteEmail, goHome } = useNewAccountActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    openNewAccount({
      onResponse,
      onError,
      body: {
        primaryEmail: state?.newAccountForm?.primaryEmail,
        password: state?.newAccountForm?.password,
        passwordConfirmation: state?.newAccountForm?.passwordConfirmation,
        inviteEmail: state?.newAccountForm?.inviteEmail,
        inviteCode: state?.newAccountForm?.inviteCode,
        userFirstName: state?.newAccountForm?.firstName,
        userLastName: state?.newAccountForm?.lastName,
        authenticityToken: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormRow>
        <Field label="First name" id="user_first_name">
          <Input
            type="text"
            name="user[first_name]"
            value={state?.newAccountForm?.firstName}
            onChange={(e) => updateFirstName(e.target.value)}
          />
        </Field>

        <Field label="Last name" id="user_last_name">
          <Input
            type="text"
            name="user[last_name]"
            value={state?.newAccountForm?.lastName}
            onChange={(e) => updateLastName(e.target.value)}
          />
        </Field>
      </FormRow>

      <Field label="Chosen Account Email" id="user_email">
        <Input
          type="email"
          name="user[email]"
          value={state?.newAccountForm?.primaryEmail}
          onChange={(e) => updatePrimaryEmail(e.target.value)}
        />
      </Field>

      <Field label="Password" id="user_password">
        <Input
          type="password"
          name="user[password]"
          value={state?.newAccountForm?.password}
          onChange={(e) => updatePassword(e.target.value)}
        />
      </Field>

      <Field label="Password confirmation" id="user_password_confirmation">
        <Input
          type="password"
          name="user[password_confirmation]"
          value={state?.newAccountForm?.passwordConfirmation}
          onChange={(e) => updatePasswordConfirmation(e.target.value)}
        />
      </Field>

      <Field label="Invite Email" id="user_invite_email">
        <Input
          type="email"
          name="user[invite_email]"
          value={state?.newAccountForm?.inviteEmail}
          onChange={(e) => updateInviteEmail(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => goHome()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Create my account
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewAccountForm;
